export default __webpack_public_path__ + "static/media/cesto_castagne.217e08ff.svg";